import React, {useState} from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import {graphql} from 'gatsby'
import Link from '../Link/Link'
import { GatsbyImage } from 'gatsby-plugin-image'
import useInterval from 'use-interval'
import './Carousel.scss'

const Slide = ({title, image, text, link}) => {
	return(
		<motion.article
			layout
			className="Carousel-Slide"
			initial={{opacity: 0}}
			animate={{opacity: 1}}
			exit={{opacity: 0}}
		>
			<motion.div
				className="image"
				initial={{y: 100, opacity: 0}}
				animate={{y: 0, opacity: 1, transition: {type: 'tween', ease: 'easeOut'}}}
				exit={{y: -100, opacity: 0, transition: {type: 'tween', ease: 'easeOut'}}}
			>
				<div className="image-inner">
					<GatsbyImage image={image.localFile.childImageSharp.gatsbyImageData} alt={`${title} | Lovdata Pro`} />
				</div>
			</motion.div>
			<div className="content">
				<h1>{title}</h1>
				{ text && <p>{text}</p> }
				{ link && <Link {...link} type={"arrow"} color="primary" />}
			</div>
		</motion.article>
	)
}

const Carousel = ({button, items}) => {
	const [currentSlide, setCurrentSlide] = useState(0);
	const [isPlaying, setIsPlaying] = useState(true);

	const nextSlide = () => {
		setIsPlaying(false)
		if(currentSlide < items.length - 1) {
			setCurrentSlide(currentSlide => currentSlide  + 1)
		} else {
			setCurrentSlide(() => 0)
		}
	}

	const prevSlide = () => {
		setIsPlaying(false)
		if(currentSlide > 0) {
			setCurrentSlide(currentSlide => currentSlide - 1)
		} else {
			setCurrentSlide(() => items.length - 1)
		}
	}

	const gotoSlide = (i) => {
		setIsPlaying(false)
		setCurrentSlide(i)
	}

	useInterval(() => {
		if(isPlaying) {
			if(currentSlide < items.length - 1) {
				setCurrentSlide(currentSlide => currentSlide  + 1)
			} else {
				setCurrentSlide(() => 0)
			}
		}
	}, 5000, false)

	return(
		<div className="Carousel">
			<div className="Carousel-wrapper">
				<AnimatePresence mode="wait">
					{
						items && items.map((item, i) => {
							if(i === currentSlide) {
								return <Slide key={`Carousel-Slide-${i}`} {...item} />
							}
							return null
						})
					}
				</AnimatePresence>
				<nav className="Carousel-nav">
					<button className="nav-button prev" onClick={prevSlide}>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.011 20.951">
							<g>
								<path d="M37.759,23.354l-7.88-7.88,2.6-2.6L42.95,23.354,32.475,33.83l-2.6-2.6Z" transform="translate(-18.94 -12.879)" fillRule="evenodd"/>
								<path d="M12,27H32.191v3.671H12Z" transform="translate(-12 -18.36)" />
							</g>
						</svg>
						<span className="screen-reader-only">Forrige</span>
					</button>
					<ul>
						{
							items.map((item, i) => <li key={`Carousel-Nav-${i}`}><button className={i === currentSlide ? 'active' : ''} onClick={() => gotoSlide(i)} ><span className="screen-reader-only">Gå til {i}</span></button></li>)
						}
					</ul>
					<button className="nav-button next" onClick={nextSlide}>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.011 20.951">
							<g>
								<path d="M37.759,23.354l-7.88-7.88,2.6-2.6L42.95,23.354,32.475,33.83l-2.6-2.6Z" transform="translate(-18.94 -12.879)" fillRule="evenodd"/>
								<path d="M12,27H32.191v3.671H12Z" transform="translate(-12 -18.36)" />
							</g>
						</svg>
						<span className="screen-reader-only">Neste</span>
					</button>
				</nav>
			</div>
		</div>
	)
}

export default Carousel
export const query = graphql`
	fragment Carousel on WpPage_Layout_block_Layout_Carousel {
		fieldGroupName
		button {
			title
			url
			target
		}
		items {
			image {
				localFile {
					childImageSharp {
						gatsbyImageData(width: 400, height: 400, transformOptions: {cropFocus: CENTER})
					}
				}
			}
			title
			text
			link {
				title
				url
				target
			}
		}
	}
`